import { z } from 'zod'

/**
 * A JSON Schema registered by an admin. The server validates the body itself
 * is a valid JSON Schema (draft-07 or 2020-12) but stores it as opaque JSON.
 */
export const SchemaNameSchema = z.string().regex(/^[a-z][a-z0-9_-]{0,63}$/, {
  message:
    'schema name must start with a lowercase letter and contain only lowercase alphanumerics, underscore, or dash',
})

export const JsonSchemaBodySchema = z
  .object({
    $schema: z.string().optional(),
    title: z.string().optional(),
    type: z.string().optional(),
  })
  .catchall(z.unknown())

export const CreateSchemaVersionSchema = z.object({
  name: SchemaNameSchema,
  version: z.number().int().positive(),
  jsonSchema: JsonSchemaBodySchema,
})

export const SchemaVersionSchema = z.object({
  id: z.string().uuid(),
  name: SchemaNameSchema,
  version: z.number().int().positive(),
  jsonSchema: JsonSchemaBodySchema,
  deprecated: z.boolean(),
  createdAt: z.string().datetime({ offset: true }),
  createdBy: z.string().uuid().nullable(),
})

export const SchemaSummarySchema = z.object({
  name: SchemaNameSchema,
  latestVersion: z.number().int().positive(),
  versions: z.number().int().nonnegative(),
  createdAt: z.string().datetime({ offset: true }),
  anyDeprecated: z.boolean(),
})

export type SchemaName = z.infer<typeof SchemaNameSchema>
export type JsonSchemaBody = z.infer<typeof JsonSchemaBodySchema>
export type CreateSchemaVersion = z.infer<typeof CreateSchemaVersionSchema>
export type SchemaVersion = z.infer<typeof SchemaVersionSchema>
export type SchemaSummary = z.infer<typeof SchemaSummarySchema>
